import {Component, EventEmitter, forwardRef, Input, OnInit, Output, ViewEncapsulation, ChangeDetectionStrategy} from '@angular/core';
import {ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR} from '@angular/forms';
import {CustomButtonToggleOption} from '../../_types/shared';
import {Community} from "../../_types/communities";
import {ThemeService} from "../../_services/theme.service";

@Component({
    selector: 'app-custom-toggle-group',
    templateUrl: './custom-toggle-group.component.html',
    styleUrl: './custom-toggle-group.component.scss',
    encapsulation: ViewEncapsulation.None,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => CustomToggleGroupComponent),
            multi: true,
        },
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CustomToggleGroupComponent implements ControlValueAccessor, OnInit {
    @Input() options: CustomButtonToggleOption[] = [];
    @Input() compact: boolean = false;
    @Input() community: Community | null = null;
    @Input() styledDatePicker: boolean = false;
    @Input() defaultValue: any;
    @Output() buttonClick: EventEmitter<void> = new EventEmitter<void>();
    control: FormControl<any> = new FormControl();

    constructor(protected themeService: ThemeService) {
    }

    ngOnInit(): void {
        if (this.defaultValue != null) {
            this.control.setValue(this.defaultValue)
            this.buttonClick?.emit(this.defaultValue)
        }
    }

    onChange: (value: any) => void = (value: any): void => {
        this.buttonClick?.emit(value)
    };
    onTouched: () => void = (): void => {
    };

    writeValue(value: any): void {
        this.control.setValue(value);
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    setDisabledState?(isDisabled: boolean): void {
        isDisabled ? this.control.disable() : this.control.enable();
    }

    getColour(input: string, value: string): string | null {
        if (value != this.control.value || !this.styledDatePicker || !this.community) {
            return null;
        }
        let colour = null
        switch (input) {
            case 'Last year':
                colour = this.community?.last_year_leaderboard_filter_color_hex ? this.community?.last_year_leaderboard_filter_color_hex : null
                break;
            case 'All time':
                colour = this.community?.all_time_leaderboard_filter_color_hex ? this.community?.all_time_leaderboard_filter_color_hex : null
                break;
            case 'This month':
                colour = this.community?.this_month_leaderboard_filter_color_hex ? this.community?.this_month_leaderboard_filter_color_hex : null
                break;
        }
        return colour
    }
}
